<template lang="html">
    <vs-popup :active.sync="$props.popupActive" title="Afficher les personnes contactées">
		<FilterCard
			:refreshKey="1"
			:showListLength="allLeads.length"
			:key="filterRefreshKey"
			:isOpen="true"
			:filters="filtersTemplates"
			@filter="handleFilterEmits($event)"
			:onChangeEmit="true"
			@clearAll="resetAllFilter()"
		/>
        <vs-table
        v-if = "!isLoading"
		stripe pagination max-items="25"
		:data="filteredLeads"
		:max-height= "tableHeight + 'px'"
		id="tb"
		class="mt-5"
		noDataText="Aucune contract corresponde"
    >
    <template slot="thead">
        <vs-th class="th-sticky" style="pointer-events: auto" sort-key="company_url">Company Url</vs-th>
        <vs-th class="th-sticky" style="pointer-events: auto" sort-key="first_name">Prenom Nom</vs-th> 
        <vs-th class="th-sticky" style="pointer-events: auto" sort-key="project_name">Nom de la recherche</vs-th> 
        <vs-th class="th-sticky" style="pointer-events: auto" sort-key="project_name">Envoyé Par</vs-th> 
        <vs-th class="th-sticky" style="pointer-events: auto" sort-key="campaignName">Campaign</vs-th>
        <vs-th class="th-sticky" style="pointer-events: auto" sort-key="statusText">Statut</vs-th>
        <vs-th class="th-sticky" style="pointer-events: auto" sort-key="createdAt">Date</vs-th>
        <!-- <vs-th class="th-sticky pdl0">Note</vs-th>
        <vs-th class="th-sticky pdl0">Date</vs-th> -->
    </template>


    <template slot-scope="{data}">
	<vs-tr :key="index" v-for="(lead, index) in data">
		<!--For just calculating the number of rows-->
		<!--For just calculating the number of rows-->
		<vs-td :data="lead.company_url">
			<a :href="lead.company_url" target="_blank">{{ lead.company_url }}</a>
		</vs-td>
		<vs-td :data="lead.first_name + ' ' + lead.last_name">
			{{ lead.first_name + " " + lead.last_name }}
		</vs-td>
		<vs-td :data="lead.project_name">
			<a :href="'prospectsProject/details/' + lead.projectId" target="_blank">
				{{ lead.project_name }}</a
			>
		</vs-td>
		<vs-td :data="lead.sent_user_name">
			{{ lead.sent_user_name }}
		</vs-td>
		<vs-td :data="lead.campaignName">
			{{ lead.campaignName }}
		</vs-td>
		<vs-td :data="lead.statusText">
			{{ lead.statusText }}
		</vs-td>
		<vs-td :data="lead.createdAt">
			{{ lead.createdAt ? convertToReadableDate(lead.createdAt) : "" }}
		</vs-td>
		<!-- <vs-td>
			{{ new Date(note.created_date).toISOString().split("T")[0] }}
		</vs-td> -->
	</vs-tr>
</template>
    </vs-table>
    <div v-else>
        <CircularLoader/>
    </div>
             <!-- </vx-card> -->
            </vs-popup>
         </template>

	<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import moment from "moment";
import FilterCard from "@/views/filters/FilterCard.vue";
// import VueCookies from "vue-cookies";
import store from "@/store/store";
import ProspectSearch from "../../entities/ProspectSearch";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
export default {
	name: "AllNotesPopup",
	mixins: [dbFieldConvertor],
	props: {
		popupActive: Boolean,
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			allLeads: [],
			isLoading: false,
			filterLeads: [],
			lemlist_status: [],

			// Filter 
			filterRefreshKey: 0,
			filtersTemplates: [
				{
					order: 0, // Filter order compared to others
					emitSlugName: "filter_company",
					filterPlaceHolder: "Entreprise",
					value: "", // Consultant id
					type: "Input",
				},
				{
					order: 1,
					emitSlugName: "filter_name",
					filterPlaceHolder: "Nom ou Prenom",
					value: "",
					type: "Input",
				},
				{
					order: 2,
					emitSlugName: "filter_status",
					filterPlaceHolder: "Statut",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [

						],
					},
				},
				{
					order: 3,
					emitSlugName: "filter_commercial",
					filterPlaceHolder: "Commercial",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						multiple: false,
						dropdownValues: [],
					},
				},
			],
		};
	},
	created() {
		this.getStatus();
		this.getAllProccesedLeads();
		this.getAllCollaborators();
	},
	updated() {
		// //console.log("dsadsads");
		// this.getNotes();
	},
	components: {
        CircularLoader,
		FilterCard
    },
	mounted() {},
	computed: {
		allCollaborators: () => {
			return store.state.collaborators;
		},
		filteredLeads() {
   			 return this.allLeads.filter((lead) => {
				return (
					(!this.filtersTemplates[0].value || lead.company_url.includes(this.filtersTemplates[0].value)) &&
					(!this.filtersTemplates[1].value || `${lead.first_name.toLowerCase()} ${lead.last_name.toLowerCase()}`.includes(this.filtersTemplates[1].value.toLowerCase())) &&
					(!this.filtersTemplates[2].value || this.filtersTemplates[2].value.includes(lead.activities[0].typeObject.text))&&
					(!this.filtersTemplates[3].value || this.filtersTemplates[3].value == lead.sent_user_id)
				);
				});
  		},
		// allCollaboratorsAvatar: () => {
		// 	return store.state.collaborators_avatar;
		// },
		// allCollaborators: () => {
		// 	return store.state.collaborators;
		// },
		// activeUser: () => {
		// 	return VueCookies.get("userInfo");
		// },
		// apiUrl: () => {
		// 	return store.state.backendApiUrl;
		// }
	},
	watch: {
		filteredLeads(data) {
			store.dispatch("setRowNum", data.length)
		},
		allCollaborators: function (data) {
			let foundCommercialFilterId = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == "filter_commercial"
			);
			if (foundCommercialFilterId) {
				this.filtersTemplates[foundCommercialFilterId].params.dropdownValues =
					data
						.filter((collaborator) => [4, 6, 9].includes(collaborator.type))
						.sort((a, b) => {
							return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
						})
						.map((row) => {
							return { id: row.id, name: row.firstname + " " + row.lastname };
						});
			}
		}
	},
	methods: {
		getAllCollaborators() {
			store.dispatch("getAllCollaborators");
		},
        convertToReadableDate(date) {
			return moment(date).format("DD/MM/YYYY");
		},
		async getAllProccesedLeads() {
			try {
                this.isLoading = true;
				this.allLeads = await ProspectSearch.getAllProccessLeads();
				this.allLeads = this.allLeads.map(lead => {
				try {
					const activity = lead.activities[0] || {};
					return {
						...lead,
						campaignName: activity.campaignName || '',
						statusText: activity.typeObject.text || '',
						createdAt: activity.createdAt || '',
					};
				} catch (error) {
					// In case of any error, set all new properties to empty strings
					return {
						...lead,
						campaignName: '',
						statusText: '',
						createdAt: '',
					};
				}
			});

			} catch (e) {
				console.log(e);
			} finally {
                this.isLoading = false;
            }
		},
		async getStatus() {
			try {
				this.lemlist_status = await ProspectSearch.getStatus();
				this.filtersTemplates[2].params.dropdownValues = this.lemlist_status;
			} catch (e) {
				console.log(e);
			}
		},
		handleFilterEmits([ emitSlugName, value ]) {
			const filter = this.filtersTemplates.find((f) => f.emitSlugName === emitSlugName);
			if (filter) {
				filter.value = value.value;
				}
		},

		
	},

};
</script>
